import EditIcon from '@mui/icons-material/Edit';
import VisibilityIcon from '@mui/icons-material/Visibility';
import React, { Fragment, useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import { useForm } from 'react-hook-form';
import WithLogin from '../withLogin.component';
import { fetchPartnerList, deletePartnerById, activatePartnerById, deactivatePartnerById } from '../../services/partner.service';
import AddParner from './partnerAdd.component'
import EditPartner from './partnerEdit.component'
import DeleteIcon from '@mui/icons-material/Delete';
import { customTableStyles, dateTimeFormat } from '../../utils';
import MessageContainer from '../message.component';
import DataTable from 'react-data-table-component';
import DeleteConfirmation from '../deleteConfirmation.component';
import ActiveConfirmation from '../activeConfimation.component'
import CheckCircleIcon from '@mui/icons-material/CheckCircle';
import CancelIcon from '@mui/icons-material/Cancel';

const Partner = () => {
    const [data, setData] = useState([]);
    const [loading, setLoading] = useState(false);
    const [totalRows, setTotalRows] = useState(0);
    const [perPage, setPerPage] = useState(10);
    const [page, setPage] = useState(1);
    const [openAddForm, setOpenAddForm] = useState(false);
    const [openEditForm, setOpenEditForm] = useState(false);
    const [isPartnerActiveOrDeactiveStatus, setIsPartnerActiveOrDeactiveStatus] = useState(false);
    const [isPartnerActiveOrDeactiveText, setIsPartnerActiveOrDeactiveText] = useState(false);
    const [showDeleteConfirmation, setShowDeleteConfirmation] = useState(false);
    const [selectedRow, setSelectedRow] = useState({});
    const [message, setMessage] = useState({});

    const [partnerSearchFilters, setPartnerSearchFilters] = useState({
        searchText: '',
    });

    const columns = [
        {
            name: 'ID',
            selector: row => row.id,
            width: '10%',
        },
        {
            name: 'Partner Name',
            selector: row => `${row.name}`,
            width: '15%',
        },
        {
            name: 'Contact Name',
            selector: row => row.contact_name,
            width: '15%',
        },
        {
            name: 'Email',
            selector: row => row.contact_email,
            width: '15%',
        },
        {
            name: 'Mobile Number',
            selector: row => row.contact_number,
            width: '10%',
        },
        {
            name: 'Active',
            selector: row => (row.is_active ? 'Active' : 'Inactive'),
            width: '10%',
        },
        {
            name: 'Created at',
            selector: row => dateTimeFormat(row.created_at),
            width: '15%',
        },
        {
            key: 'action',
            text: 'Action',
            name: 'Action',
            className: 'action',
            align: 'left',
            width: '10%',
            sortable: false,
            cell: row => {
                return (
                    <Fragment>
                        <span className="table-action-icon">
                            <EditIcon
                                titleAccess='Edit'
                                className="icon-color"
                                onClick={() => {
                                    onEdit(row);
                                }}
                            />
                        </span>
                        &nbsp;
                        <span className="table-action-icon">
                            <Link
                                to={`/partners/${row.id}/`}
                                className="table-action-icon">
                                <VisibilityIcon titleAccess='view'/>
                            </Link>
                        </span>
                        {!row.is_account_created &&
                            <span className="table-action-icon">
                                <DeleteIcon
                                    titleAccess='delete'
                                    color="red"
                                    className="table-action-icon red"
                                    onClick={() => onDelete(row)}
                                />
                            </span>
                        }
                        {row.is_active &&
                            <span className="table-action-icon">
                                <CancelIcon
                                    titleAccess='deactivate'
                                    color="red"
                                    className="table-action-icon red"
                                    onClick={() => onActiveOrDeactiveChange(row, 'deactivate')}
                                />
                            </span>
                        }
                        {!row.is_active &&
                            <span className="table-action-icon">
                                <CheckCircleIcon
                                    titleAccess='activate'
                                    color="red"
                                    className="table-action-icon red"
                                    onClick={() => onActiveOrDeactiveChange(row, 'activate')}
                                />
                            </span>
                        }
                    </Fragment>
                );
            },
        },
    ];

    const onActiveOrDeactiveChange = async (row, text) => {
        setIsPartnerActiveOrDeactiveStatus(true);
        setIsPartnerActiveOrDeactiveText(text)
        setSelectedRow(row);
    }

    const onDelete = async row => {
        setShowDeleteConfirmation(true);
        setSelectedRow(row);
    };

    const onEdit = row => {
        setSelectedRow(row);
        setOpenEditForm(true);
    };

    const handleOpenAddForm = () => {
        setOpenAddForm(true);
    };

    const getPartners = async (toPage, toPerPage) => {
        setLoading(true);
        setMessage({});
        toPage = toPage ? toPage : page;
        toPerPage = toPerPage ? toPerPage : perPage;
        try {
            const partners = await fetchPartnerList(
                toPage,
                toPerPage,
                partnerSearchFilters,
            );
            setData(partners.items);
            setTotalRows(partners.total);
        } catch (error) {
            setMessage({
                detail: 'An error has occurrded during data loading.',
                type: 'Error',
            });
        }
        setLoading(false);
    };

    useEffect(() => {
        getPartners(1);
    }, []); // eslint-disable-line react-hooks/exhaustive-deps

    const handlePageChange = toPage => {
        getPartners(toPage);
        setPage(toPage);
    };

    const handlePerRowsChange = async (newPerPage, page) => {
        await getPartners(page, newPerPage);
        setPerPage(newPerPage);
    };

    const { register, handleSubmit, reset } = useForm({
        defaultValues: {},
    });

    useEffect(() => {
        getPartners(1);
        setPage(1);
    }, [partnerSearchFilters]); // eslint-disable-line react-hooks/exhaustive-deps


    const setSearchFilters = async data => {
        setPartnerSearchFilters({
            searchText: data.searchText.trim(),
        });
    };

    const reloadDataTable = toPage => {
        getPartners(toPage);
        if (toPage) {
            setPage(toPage);
        }
    };

    const partnerStatusChange = async id => {
        setMessage({});
        try {
            let resp = ''
            if (isPartnerActiveOrDeactiveText === 'activate') {
                resp = await activatePartnerById(id);
            }
            else if (isPartnerActiveOrDeactiveText === 'deactivate') {
                resp = await deactivatePartnerById(id);
            }
            reloadDataTable(page);
            setMessage({
                type: 'Success',
                message: `${resp.detail}`,
            });
        } catch (error) {
            if (
                error.response.status === 400 ||
                error.response.status === 404
            ) {
                setMessage({
                    type: 'Error',
                    message: `${error.response.data.detail}`,
                });
            }
        }
        setIsPartnerActiveOrDeactiveStatus(false);
    };

    const deletePartner = async id => {
        setMessage({});
        try {
            const resp = await deletePartnerById(id);
            reloadDataTable(page);
            setMessage({
                type: 'Success',
                message: `${resp.detail}`,
            });
        } catch (error) {
            if (
                error.response.status === 400 ||
                error.response.status === 404
            ) {
                setMessage({
                    type: 'Error',
                    message: `${error.response.data.detail}`,
                });
            }
        }
        setShowDeleteConfirmation(false);
    };

    return (
        <>
            {openAddForm && (
                <AddParner
                    open={openAddForm}
                    setOpenAddForm={setOpenAddForm}
                    reloadDataTable={reloadDataTable}
                />
            )}
            {openEditForm && (
                <EditPartner
                    open={openEditForm}
                    setEditForm={setOpenEditForm}
                    selectedRow={selectedRow}
                    reloadDataTable={reloadDataTable}
                />
            )}
            <div>
                <div className="pageHeader">
                    <span id="header">
                        <h4>Partners</h4>
                    </span>
                    <span id="header-add-btn">
                        <button
                            className="btn btn-primary"
                            onClick={handleOpenAddForm}>
                            + Add Partner
                        </button>
                    </span>
                </div>

                <hr />

                {message && <MessageContainer message={message} />}
                <form className="row g-2" onSubmit={handleSubmit(setSearchFilters)}>
                    <div className="col-md-3">
                        <input
                            type="text"
                            className="form-control"
                            id="search"
                            placeholder="Enter partner's name email"
                            {...register('searchText')}
                        />
                    </div>
                    <div className="col-md-9">
                        <button
                            type="submit"
                            className="btn btn-primary"
                            disabled={loading}>
                            {loading && (
                                <span className="spinner-border spinner-border-sm"></span>
                            )}
                            Search
                        </button>
                        <span className="mx-1"></span>
                        <button
                            type="submit"
                            className="btn btn-primary"
                            disabled={loading}
                            onClick={() => {
                                reset();
                            }}>
                            Reset
                        </button>
                    </div>
                </form>
                <div className="new-line"></div>
                <div className="admin-list-table">
                    <DataTable
                        width="100%"
                        customStyles={customTableStyles}
                        columns={columns}
                        data={data}
                        progressPending={loading}
                        pagination
                        paginationServer
                        paginationDefaultPage={page}
                        paginationResetDefaultPage={true}
                        paginationTotalRows={totalRows}
                        onChangeRowsPerPage={handlePerRowsChange}
                        onChangePage={handlePageChange}
                    />
                </div>
                <DeleteConfirmation
                    showModal={showDeleteConfirmation}
                    hideModal={() => setShowDeleteConfirmation(false)}
                    confirmModal={deletePartner}
                    deleteId={selectedRow.id}
                    message="Are you sure you want to delete it"
                />
                <ActiveConfirmation
                    displayText={isPartnerActiveOrDeactiveText}
                    buttonText={isPartnerActiveOrDeactiveText}
                    showModal={isPartnerActiveOrDeactiveStatus}
                    hideModal={() => setIsPartnerActiveOrDeactiveStatus(false)}
                    confirmModal={partnerStatusChange}
                    id={selectedRow.id}
                    message={`Are you sure you want to ${isPartnerActiveOrDeactiveText} it`}
                />
            </div>
        </>
    )
}

export default WithLogin(Partner);